<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-items-center">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide" v-text="text"></span>
    <div class="wf-w-1/2">
      <vue-slider
        ref="content-slider"
        v-model="value"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="dataSlider"
      ></vue-slider>
    </div>
  </li>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  import _ from 'lodash'
export default MenuContentProperty.extend({
    props: {
      text: {
        type: String,
        required: false,
        default: 'Text'
      },
      property: {
        type: String,
        required: false,
        default: 'text'
      },
      dataSlider: {
        type: [Array, Object],
        required: true,
        default: function () {
          return [1, 2]
        }
      }
    },
    computed: {
      value: {
        get() {
          return this.elementContent[this.property]
        },
        set: _.debounce(function (value) {
          let object = new Object
          this.$set(object, this.property, value)
          this.addToObject(this.module, object, 'content')
        }, 50)
      },
    }
  })
</script>
